import { render, staticRenderFns } from "./lab.vue?vue&type=template&id=46950fd0"
import script from "./lab.vue?vue&type=script&lang=js"
export * from "./lab.vue?vue&type=script&lang=js"
import style0 from "./lab.vue?vue&type=style&index=0&id=46950fd0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports